import { render, staticRenderFns } from "./StudentLeaveReportPrint.vue?vue&type=template&id=46a440a7&scoped=true&"
import script from "./StudentLeaveReportPrint.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveReportPrint.vue?vue&type=style&index=0&id=46a440a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a440a7",
  null
  
)

export default component.exports